'use strict';

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!
angular
    .module('MW.InsDashboard.InsWidgetConfigService', [
        'MW.Framework.TranslationService',
        'MW.InsDashboard.insightsBackendService',
        'DashboardChartConfigService',
        'MW.Dashboard.DashboardStateService',
        'MW.Framework.NavBarService'
    ])

.factory('InsWidgetConfigService', [
    'translationService',
    'insightsBackendService',
    'DashboardChartConfigService',
    'DashboardStateService',
    '$q',
    'CoreUserService',
    'moment',
    '$routeParams',
    function (translationService, insightsBackendService, DashboardChartConfigService, DashboardStateService, $q, CoreUserService, moment, $routeParams) {
    var serviceObj = {};
    var chartAnimation = {};
    serviceObj.chartAnimationPeriodToDisable = 1000 * 60 * 5;//5 minutes

    //Seed the chart last animated time stamp. To be used to see if we need to animate again
    var setChartAnimationStatus = function(widgetID){
        //seed with a time stamp, number of milliseconds since January 1, 1970
        chartAnimation[widgetID] = new Date().getTime();
    };

    //Checks to see if we need to animate the chart again.
    //This basically checks to see if we have loaded in the last x minutes.
    //If nothing is set we stamp it as new and default to return true (to animate).
    var getChartAnimationStatus = function(widgetID){
        //if the property for the requested widget is not set yet default it to true
        if(typeof chartAnimation[widgetID] === "undefined") {
            setChartAnimationStatus(widgetID);
            return true;
        }

        //check to see if we passed the target time window
        var isPast = (new Date().getTime() - chartAnimation[widgetID]) > serviceObj.chartAnimationPeriodToDisable;
        //reseed the time since we passed and need to refresh again
        if(isPast) {
            setChartAnimationStatus(widgetID);
        }
        return isPast;
    };

    serviceObj.getChartAnimationStatus = getChartAnimationStatus;


    // Turn widget settings into document request parameters
    function setInputQueryParameters (settings, selectedId){
        selectedId = selectedId || false;
        var params = {};
        if(settings.inputs){
            angular.forEach(settings.inputs, function(singleInput){
                if(singleInput){
                switch (singleInput.inputType){
                    case 'tags':
                        if(!params.tags){
                            params.tags = [];
                        }
                        if((selectedId && singleInput.name == selectedId) || !selectedId){
                            params.tags.push(singleInput.name);
                        }
                        break;
                    case 'rss':
                        if(!params.rssFeeds){
                            params.rssFeeds = [];
                        }
                        if((selectedId && singleInput.id == selectedId) || !selectedId){
                            params.rssFeeds.push(singleInput.id);
                        }
                        break;
                    default:
                        if(!params.agents){
                            params.agents = [];
                        }
                        if((selectedId && singleInput.id == selectedId) || !selectedId){
                            params.agents.push(singleInput.id);
                        }
                        break;
                    }
                }
            });
        }else if(settings.searchIds){
            angular.forEach(settings.searchIds, function(singleInput){
                if(!params.agents){
                    params.agents = [];
                }
                if((selectedId && singleInput.searchId == selectedId) || !selectedId){
                    params.agents.push(singleInput.searchId);
                }
            });
        }
        return params;
    }



    //This function does most of the heavy lifting to get the chart request, document request, date, and filter objects ready to make a request to harfagre
    var readyWidgetData = function(scope){
        var applyTimezoneOverride = function (inputTime, dateFormat) {
            var converted,
                format,
                inputTimezone,
                local;
            format = dateFormat || 'YYYY-MM-DD';
            inputTimezone = CoreUserService.getTimezone();
            local = moment(inputTime).clone().tz(inputTimezone).format(format);
            converted = moment.tz(local, format, scope.timezoneOverride);
            return converted;
        }

        var groupOption;

        scope.searches = [];
        scope.fromDate = null;
        scope.toDate = null;
        scope.readyToQuery = false;
        scope.currentTimezone = scope.timezoneOverride || CoreUserService.getTimezone();

        var savedFilters = {};
        if(scope.widget.filters){
            savedFilters = DashboardChartConfigService.setFilters(scope.widget);
        }

        if (scope.widget.settings.searchIds && scope.widget.settings.searchIds.length > 0) {
            angular.forEach(scope.widget.settings.searchIds, function(searchId){
                scope.searches.push({name:searchId.name, agent:searchId.searchId, color:searchId.color || 'default'});
            });
        }

        if (scope.widget.settings.inputs && scope.widget.settings.inputs.length > 0) {
            scope.inputs = scope.widget.settings.inputs;
        }


        var basicRequest = {
            sortField: 'date',
            sortOrder: 'DESC'
        };

        if(scope.widget.settings.dateRange && typeof scope.widget.settings.dateRange.granularity !== 'undefined') {
            scope.granularity = scope.widget.settings.dateRange.granularity;
        }

        var endDate,
            startDate;

        if (scope.timezoneOverride) {
            if(scope.widget.settings.customDateRange){
                startDate = applyTimezoneOverride(scope.widget.settings.dateRange.absoluteStartDate).tz(scope.timezoneOverride).toISOString();
                endDate = applyTimezoneOverride(scope.widget.settings.dateRange.absoluteEndDate).tz(scope.timezoneOverride).endOf('day').toISOString();
                scope.granularity = scope.widget.settings.dateRange.granularity;
            } else {
                var db = DashboardStateService.currentDashboard;
                startDate = applyTimezoneOverride(db.currentDateRange.absoluteStartDate).tz(scope.timezoneOverride).toISOString();
                endDate = applyTimezoneOverride(db.currentDateRange.absoluteEndDate).tz(scope.timezoneOverride).endOf('day').toISOString();
                scope.granularity = scope.granularity || db.currentDateRange.granularity;
            }
        } else if (scope.widget.settings.customDateRange) {
            startDate = scope.widget.settings.dateRange.absoluteStartDate;
            endDate = scope.widget.settings.dateRange.absoluteEndDate;
            scope.granularity = scope.widget.settings.dateRange.granularity;
        } else {
            var db = DashboardStateService.currentDashboard;
            startDate = db.currentDateRange.absoluteStartDate;
            endDate = db.currentDateRange.absoluteEndDate;
            scope.granularity = scope.granularity || db.currentDateRange.granularity;
        }

        if (scope.timezoneOverride) {
            scope.fromDate = startDate;
            scope.toDate = endDate;
        } else {
            scope.fromDate = moment(startDate).utc().tz(scope.currentTimezone).startOf('day').format();
            scope.toDate = moment(endDate).utc().tz(scope.currentTimezone).endOf('day').format();
        }

        scope.timeInterval = DashboardChartConfigService.getTimeInterval(scope.granularity);
        basicRequest.dateStart=scope.fromDate;
        basicRequest.dateEnd=scope.toDate;
        basicRequest.dateStartTag=scope.fromDate;
        basicRequest.dateEndTag=scope.toDate;
        basicRequest.dateQueryStart=scope.widgetLoadTime;

        if(DashboardStateService.refreshCache) {
            basicRequest.refreshCache = true;
            DashboardStateService.refreshCache = false;
        }

        scope.readyToQuery = ((scope.searches.length > 0 || (scope.inputs && scope.inputs.length > 0)) && scope.fromDate && scope.toDate) ? true : false;

        if(typeof scope.queryRequestSettings === 'undefined'){
            serviceObj.queryRequestSettings = angular.extend(basicRequest, savedFilters);
        }
        else
        {
            serviceObj.queryRequestSettings = angular.extend(scope.queryRequestSettings, savedFilters);
        }
        serviceObj.queryRequestSettings.pageSize =25;
        serviceObj.queryRequestSettings.page = 0;
        scope.chartRequest = angular.extend(basicRequest, savedFilters);


        if(insightsBackendService.validateParameter(scope.insightsService, 'granularity')){
            scope.chartRequest.granularity = scope.granularity;
        }

        //---------------->8----------------//

        scope.realFHaccess='real';

        if(insightsBackendService.validateParameter(scope.insightsService, 'searchTerm')){
            scope.chartRequest.searchTerm = scope.realFHaccess;
        }

        // For documents
        serviceObj.queryRequestSettings['searchTerm'] = scope.realFHaccess;

        //----------------8<----------------//

        if(scope.readyToQuery) {

            var inputParams = setInputQueryParameters(scope.widget.settings);

            scope.queryRequestSettings = angular.extend(serviceObj.queryRequestSettings, inputParams)

            if (scope.isMaximized) {

                // finalize the default group setting before we initialize the content stream. after this, the
                // grouping option should only be updated by the content stream so that we're not mucking with
                // the behavior of the ContentStreamTypes
                groupOption = CoreUserService.getAppSettings('sharedContentStreamSettings').groupOption;
                serviceObj.queryRequestSettings.groupOption = groupOption ? groupOption : 'close';

                if(!$routeParams.drilled) {
                    if(typeof scope.documentRequest === 'undefined'){
                        scope.documentRequest = {};
                    }
                    if(scope.documentRequest.country) {
                        serviceObj.queryRequestSettings['country'] = scope.documentRequest.country;
                    }

                    if (scope.insightsService === 'posterHistograms') {
                        if (scope.documentRequest['source']) {
                            serviceObj.queryRequestSettings['source'] =  scope.documentRequest['source'];
                        }
                    }
                } else {
                    // Load the content stream with the drilled down data, if the query parameters are present in the URL
                    if($routeParams.inputId) {
                        setInputOnQuery(scope.widget.settings, $routeParams.inputId);
                    }
                    if($routeParams.date) {
                        var numDays = DashboardChartConfigService.getTimeInterval(scope.granularity);
                        serviceObj.queryRequestSettings['dateStart'] = serviceObj.queryRequestSettings['dateStartTag'] = $routeParams.date;
                        var dateEnd = CoreUserService.adjustDate($routeParams.date);
                        dateEnd.add(numDays, 'days');
                        serviceObj.queryRequestSettings['dateEnd'] = serviceObj.queryRequestSettings['dateEndTag'] = dateEnd;
                        if (serviceObj.queryRequestSettings['dateStart'].valueOf() < scope.fromDate.valueOf()) {
                            serviceObj.queryRequestSettings['dateStart'] = serviceObj.queryRequestSettings['dateStartTag'] = scope.fromDate;
                        }
                    }

                    if(typeof scope.documentRequest === 'undefined'){
                        scope.documentRequest = {};
                    }

                    if($routeParams.sentiment) {
                        scope.documentRequest['sentiment'] = serviceObj.queryRequestSettings['sentiment'] = $routeParams.sentiment;
                    }
                    if($routeParams.sourceId) {
                        scope.documentRequest['source'] = serviceObj.queryRequestSettings['source'] = $routeParams.sourceId;
                    }
                    if($routeParams.country) {
                        scope.documentRequest['country'] = serviceObj.queryRequestSettings['country'] = $routeParams.country;
                    }
                    if($routeParams.keyphrase) {
                        scope.documentRequest['keyphrase'] = serviceObj.queryRequestSettings['keyphrase'] = $routeParams.keyphrase;
                    }

                    if($routeParams.region) {
                        scope.documentRequest['region'] = serviceObj.queryRequestSettings['region'] = $routeParams.region;
                    }
                    if($routeParams.language) {
                        scope.documentRequest['language'] = serviceObj.queryRequestSettings['language'] = $routeParams.language;
                    }
                    if($routeParams.entity) {
                        scope.documentRequest['entity'] = serviceObj.queryRequestSettings['entity'] = $routeParams.entity;
                    }
                    if($routeParams.socialAuthor) {
                        if($routeParams.sourceId === 'facebook'){
                            scope.documentRequest['socialAuthor'] = serviceObj.queryRequestSettings['socialAuthor'] = $routeParams.socialId;
                        } else {
                            scope.documentRequest['socialAuthor'] = serviceObj.queryRequestSettings['socialAuthor'] = $routeParams.socialAuthor;
                        }
                    }
                }

                if (scope.documentRequest.associatedThemes) {
                    serviceObj.queryRequestSettings['associatedThemes'] = scope.documentRequest.associatedThemes;
                }
                else if($routeParams.associatedThemes) {
                    scope.documentRequest['associatedThemes'] = serviceObj.queryRequestSettings['associatedThemes'] = $routeParams.associatedThemes.split(',');
                }

                if (serviceObj.queryRequestSettings['associatedThemes'] && serviceObj.queryRequestSettings['associatedThemes'].length > 0) {
                    for (var i = 0; i < serviceObj.queryRequestSettings['associatedThemes'].length; i++) {
                        serviceObj.queryRequestSettings['associatedThemes'][i] = serviceObj.queryRequestSettings['associatedThemes'][i].replace(/%252C/g, '%2C');
                    }
                }

                //We watch this variable, and update the widget content stream.
                scope.updateContentStreamQuery = {
                    name: scope.breadcrumbs && scope.breadcrumbs[scope.breadcrumbs.length - 1].name,
                    query: angular.copy(serviceObj.queryRequestSettings)
                };
            } else {
                if (scope && scope.documentRequest && scope.documentRequest.country) {
                    serviceObj.queryRequestSettings['country'] = scope.documentRequest.country;
                }
            }
        }

        var handleLoadingError = function handleLoadingError() {
            scope.serviceError = true;
            scope.widgetIsLoading = false;
        };

        var handleNoDataError = function handleNoDataError() {
            scope.noDataFromServer = true;
            scope.widgetIsLoading = false;
        };

        scope.chartDataObject = {
            endpoint : insightsBackendService.consolidatedService.query,
            searches : scope.searches,
            inputs : scope.inputs,
            queryParameters : scope.chartRequest,
            insObject : scope.insightsObject,
            fromDate:scope.fromDate,
            toDate:scope.toDate,
            granularity:scope.granularity,
            loadingError: handleLoadingError,
            noDataError: handleNoDataError,
            fetchDataForPreviousRange: scope.widget.settings.dateComparison || false,
            dataLabels: scope.labelVisibility || false
        };

    };

    serviceObj.readyWidgetData = readyWidgetData;

    var setInputOnQuery = function setInputOnQuery(widgetSettings, id){
        serviceObj.queryRequestSettings.agents = [];
        serviceObj.queryRequestSettings.tags = [];
        serviceObj.queryRequestSettings.rssFeeds = [];
        var paramList = setInputQueryParameters(widgetSettings, id);
        serviceObj.queryRequestSettings = angular.extend(serviceObj.queryRequestSettings, paramList);
    }


    var dateGranularityDrilldown = function(id, date, scope, linkedTo) {
        if(typeof scope.documentRequest == 'undefined'){
            scope.documentRequest = {};
        }

        setInputOnQuery(scope.widget.settings, id);

        if(typeof scope.documentRequest.country !== 'undefined'){
            serviceObj.queryRequestSettings['country'] = scope.documentRequest.country;
        }

        if(typeof scope.documentRequest.source !== 'undefined'){
            serviceObj.queryRequestSettings['source'] = scope.documentRequest.source;
        }

        if(typeof scope.documentRequest.sentiment !== 'undefined'){
            serviceObj.queryRequestSettings['sentiment'] = scope.documentRequest.sentiment;
        }

        if(typeof scope.documentRequest.language !== 'undefined'){
            serviceObj.queryRequestSettings['language'] = scope.documentRequest.language;
        }

        if(typeof scope.documentRequest.entity !== 'undefined'){
            serviceObj.queryRequestSettings['entity'] = scope.documentRequest.entity;
        }

        if(typeof scope.documentRequest.socialAuthor !== 'undefined'){
            serviceObj.queryRequestSettings['socialAuthor'] = scope.documentRequest.socialAuthor;
        }

        if (typeof date != 'undefined') {
            serviceObj.queryRequestSettings['dateStart'] = serviceObj.queryRequestSettings['dateStartTag'] = date;

            var dateEnd = CoreUserService.adjustDate(date);

            switch (scope.granularity) {
                case 'DAY':
                    dateEnd = dateEnd.clone().add(1, 'day');
                    break;
                case 'WEEK':
                    dateEnd = dateEnd.clone().endOf('isoWeek');
                    break;
                case 'MONTH':
                case 'QUARTER':
                case 'YEAR':
                    dateEnd = dateEnd.clone().endOf(scope.granularity);
                    break;
            }

            if (moment(scope.toDate) < dateEnd) {
                dateEnd = moment(scope.toDate);
            }

            serviceObj.queryRequestSettings['dateEnd'] = serviceObj.queryRequestSettings['dateEndTag'] = dateEnd;
            //if underscores are allowed in the agent name, we might get a bug here if user names agent _previous
            if (!linkedTo || linkedTo.indexOf('_previous') === -1) {
                if (serviceObj.queryRequestSettings['dateStart'].valueOf() < scope.fromDate.valueOf()) {
                    serviceObj.queryRequestSettings['dateStart'] = serviceObj.queryRequestSettings['dateStartTag'] = scope.fromDate;
                }
                if (serviceObj.queryRequestSettings['dateEnd'].valueOf() > scope.toDate.valueOf()) {
                    serviceObj.queryRequestSettings['dateEnd'] = serviceObj.queryRequestSettings['dateEndTag'] = scope.toDate;
                }
            }
        } else {
            serviceObj.queryRequestSettings['dateStart'] = serviceObj.queryRequestSettings['dateStartTag'] = scope.fromDate;
            serviceObj.queryRequestSettings['dateEnd'] = serviceObj.queryRequestSettings['dateEndTag'] = scope.toDate;
        }

        if (typeof scope.documentRequest.refererUrls !== 'undefined') {
            serviceObj.queryRequestSettings['refererUrls'] = scope.documentRequest.refererUrls;
        }

        //We watch for updateContentStreamQuery on widget_content_stream_maximized.
        if(scope.isMaximized) {
            scope.updateContentStreamQuery = {
                name: scope.breadcrumbs && scope.breadcrumbs[scope.breadcrumbs.length - 1].name,
                query: serviceObj.queryRequestSettings
            };
        } else { //Use the old content stream.
            scope.$broadcast('contentStream_queryReset', serviceObj.queryRequestSettings);
            scope.$broadcast('contentStream_documentsLoad', serviceObj.queryRequestSettings);
        }
    };

    serviceObj.dateGranularityDrilldown = dateGranularityDrilldown;

    //Get the scaled numbers for our segmentation chart y-axes (geo, publisher)
    var getSegmentationYAxisFormatFunction = function(settings){
        var fn = function(){
            if(!settings.percentageMode) {
            var value = this.value,
            numericSymbols = Highcharts.getOptions().lang.numericSymbols,
            i = numericSymbols && numericSymbols.length,
            multi,
            ret;

            if(i && value >= 100) {
                while (i-- && ret === undefined) {
                    multi = Math.pow(1000, i + 1);
                    if (value >= multi && numericSymbols[i] !== null) {
                        if (Highcharts.numberFormat(value / multi, -1) == 0)
                            ret = "0";
                        else
                            ret = Highcharts.numberFormat(value / multi, -1) + numericSymbols[i];
                    }
                }
            }
            if (ret === undefined) {
                if (value >= 1000) { // add thousands separators
                    ret = Highcharts.numberFormat(value, 0);
                } else { // small numbers
                    ret = Highcharts.numberFormat(value, -1);
                }
            }
            return ret;
            } else {
                return '<span class="segmentYAxis">' + this.value + '%' + '</span>';
            }
        };
        return fn;
    };

    serviceObj.getSegmentationYAxisFormatFunction = getSegmentationYAxisFormatFunction;

    var getSegmentationTooltipValue = function(dataPoint, name, settings){
        var retVal, pcnt, endClass, retString;
        if(!settings.percentageMode){
            retVal=DashboardChartConfigService.addNumericSymbol(dataPoint.point.y);
            pcnt=(dataPoint.point.y/settings.dataSum)*100;
        } else {
            retVal = DashboardChartConfigService.addNumericSymbol(settings.datapoints[dataPoint.point.x]);
            pcnt = dataPoint.point.y;
        }
        retString = name + " - " + retVal + "(" + Highcharts.numberFormat(pcnt) + "%)";
        retString += "<br>"+translationService.getLocalizedString("dashboard-widgets__graph-tooltip-change")+" " + Highcharts.numberFormat(settings.diff[dataPoint.point.x], 0) + "%";
        return retString;
    };

    serviceObj.getSegmentationTooltipValue = getSegmentationTooltipValue;

    var getBarTooltipValue = function getBarTooltipValue(dataPoint, name){
        var first = DashboardChartConfigService.addNumericSymbol(dataPoint.point.volume),
            second = Highcharts.numberFormat(dataPoint.point.percent) + '%',
            retString = name + ": " + first + " (" + second + ")";

        return retString;
    };

    serviceObj.getBarTooltipValue = getBarTooltipValue;

    var getDocumentAction = function getDocumentAction(queryObject) {
        var defer = $q.defer();
        insightsBackendService.fairhairInsService.query(queryObject,
            function(data) {
                defer.resolve(data);
            }, function(err){
                defer.reject('error');
            });
        return(defer.promise);
    };

    serviceObj.getDocumentAction = getDocumentAction;

    function hasSelectedAnInput(widget){
        if(typeof widget['settings'] === 'undefined'){
            return false;
        }
        if(widget.settings.inputs && widget.settings.inputs.length > 0){
            return true;
        }
        if(widget.settings.searchIds && widget.settings.searchIds.length > 0){
            return true;
        }
        if(widget.settings.tagNames && widget.settings.tagNames.length > 0){
            return true;
        }
        return false;
    }
    serviceObj.hasSelectedAnInput = hasSelectedAnInput;

    var defaultRequiredSettings = ['dateRange', 'searchIds', 'rssFeeds'];
    serviceObj.defaultRequiredSettings = defaultRequiredSettings;

    /**
     * some social documents won't have the body if this is not included
     *
     * @see searchServiceObj.getContentStreamBySavedResources
     * @see searchServiceObj.getSingleDocument
     */
    function addAdditionalField(query) {
        query.additionalFields = 'body';

        return query;
    }

    return serviceObj;

}]);
